import React from "react";
import { faEyeSlash, faGlobeEurope } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Module from "@/components/layouts/module";

export const PublicStatus = ({ isPublic }: { isPublic: boolean }) => {
  if (isPublic) {
    return (
      <Module>
        <p className="text-center">
          This animation is{" "}
          <span className="animation-page__public shadow-md">
            <FontAwesomeIcon icon={faGlobeEurope} /> In Gallery
          </span>{" "}
          for the world to see.
        </p>
      </Module>
    );
  }

  return (
    <Module>
      <p className="text-center">
        This animation is{" "}
        <span className="animation-page__private shadow-md">
          <FontAwesomeIcon icon={faEyeSlash} /> Private
        </span>{" "}
        only you can see it.
      </p>
    </Module>
  );
};
